import { CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useAccountQuery } from "features/auth/authApi";
import { useBalancesQuery } from "features/finance/financeApi";
import React, { useEffect } from "react";
import CurrencyIcon from "components/currency-icon";
import numeral from "numeral";
import { useTranslation } from "react-i18next";
type Props = {
  isSmall?: boolean;
};
const FiatInfo: React.FC<Props> = ({ isSmall }) => {
  const [selectedAsset, setSelectedAsset] = React.useState<string>("");
  const { data: balances, isLoading } = useBalancesQuery(undefined, {
    pollingInterval: 60000,
  });

  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const { data: account } = useAccountQuery(undefined, {
    pollingInterval: 60000,
  });
  const default_currency =
    account?.user.currency || account?.user.kycProgram.default_currency;

  useEffect(() => {
    if (!selectedAsset && account?.user.kycProgram.supported_cryptos[0]) {
      setSelectedAsset(account.user.kycProgram.supported_cryptos[0]);
    }
  }, [account, selectedAsset]);

  const getAvailableFiatBalance = (currency: string | undefined) => {
    return numeral(
      currency === "usd"
        ? balances?.newArchBalances.availableUsdSum
        : balances?.newArchBalances.availableEurSum
    ).format("0,00");
  };

  return (
    <Stack
      direction={isSmall ? "column" : "row"}
      spacing={2}
      divider={<Divider orientation="vertical" flexItem />}
    >
      <Stack spacing={0.2}>
        <Typography fontWeight={600} fontSize={12}>
          {t("balance.available")}
        </Typography>
        <Typography
          fontWeight={400}
          fontSize={13}
          alignItems="center"
          display="flex"
          gap={0.5}
        >
          <CurrencyIcon currency={default_currency} size={20} />
          {isLoading ? (
            <CircularProgress size={14} />
          ) : (
            default_currency && getAvailableFiatBalance(default_currency)
          )}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default FiatInfo;
